import { createContext, PropsWithChildren, useContext } from 'react';

const SectionNameContext = createContext<string | undefined>(undefined);

export const SectionNameProvider = ({
  children,
  sectionName,
}: PropsWithChildren<{
  sectionName: string;
}>) => {
  return (
    <SectionNameContext.Provider value={sectionName}>
      {children}
    </SectionNameContext.Provider>
  );
};

export function useSectionName() {
  return useContext(SectionNameContext);
}
